import React from "react";
import { Box, Grid2 } from "@mui/material";
import {
  Add,
  Save,
  Edit,
  Print,
  DateRange,
  CheckCircle,
  Delete,
  SearchRounded,
  Cancel,
  Download,
  Refresh,
} from "@mui/icons-material";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import GenericActionButton from "./GenericActionButton";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";

const MenuBar = ({
  onNew,
  onNewPlan,
  onSave,
  onEdit,
  onPrint,
  onCancel,
  onDownload,
  onFinalize,
  onSettleBill,
  onDelete,
  onChangeDate,
  onDateRangeFilter,
  onSearchPatient,
   onCheckIn,
  onNoShow,
    onAddServices,
    onRefresh,

  onShowQueue,
  showCancel = false,
  showQueue = false,
  showDownload = false,
  showNew = false,
  showNewPlan = false,
  showSave = false,
  showEdit = false,
  showPrint = false,
  showChangeDate = false,
  showDateRangeFilter = false,
  showFinalize = false,
  showSettleBill = false,
  showDelete = false,
  showTodaysQueue = false,
  showSearchPatient = false,
   showAddServices = false,
  disabled = false,
    showCheckIn = false,
  showNoShow = false,
  showRefresh = false,

refreshDisabled = false,

  // ✅ ADD THESE TWO NEW PROPS
  saveDisabled = false,
  finalizeDisabled = false,

  newLabel = "New",
  newTooltip = "Create New",
  saveLabel = "Save",
  saveTooltip = "Save Changes",
  newPlanLabel = "New",
  newPlanTooltip = "Create New",

  editLabel = "Edit",
  editTooltip = "Edit",
  cancelLabel = "Cancel", 
  cancelTooltip = "Cancel",
  finalizeLabel = "Finalize",
  finalizeTooltip = "Finalize",
  deleteLabel = "Delete",
  deleteTooltip = "Delete",
  checkInLabel = "Check In",
  checkInTooltip = "Check In Patient",
  noShowLabel = "No Show",
  noShowTooltip = "Mark as No Show",
   addServicesLabel = "Add Services", // ADD THIS
  addServicesTooltip = "Add Services to Visit",
  
}) => (
 <Grid2
    container
    size={12}
    pb={0.5}
    pt={0.5}
    pl={1}
    sx={{ borderBottom: "2px solid lightgray", width: "100%" }}
    spacing={1}
  >
    {showNew && (
      <GenericActionButton
        label={newLabel}
        icon={<Add />}
        onClick={onNew}
        disabled={disabled}
        tooltipText={newTooltip}
      />
    )}
    {showNewPlan && (
      <GenericActionButton
        label={newPlanLabel}
        icon={<Add />}
        onClick={onNewPlan}
        disabled={disabled}
        tooltipText={newPlanTooltip}
      />
    )}
    
    {/* Edit/Reschedule Button */}
    {showEdit && (
      <GenericActionButton
        label={editLabel}
        icon={<Edit />}
        onClick={onEdit}
        disabled={disabled}
        tooltipText={editTooltip}
      />
    )}

     {showAddServices && (
      <GenericActionButton
        label={addServicesLabel}
        icon={<Add />}
        onClick={onAddServices}
        disabled={disabled}
        tooltipText={addServicesTooltip}
      />
    )}
    
    {/* Check In Button */}
    {showCheckIn && (
      <GenericActionButton
        label={checkInLabel}
        icon={<CheckCircle />}
        onClick={onCheckIn}
        disabled={disabled}
        tooltipText={checkInTooltip}
      />
    )}
    
    {/* Save Button */}
    {showSave && (
      <GenericActionButton
        label={saveLabel}
        icon={<Save />}
        onClick={onSave}
        disabled={disabled || saveDisabled}
        tooltipText={saveTooltip}
      />
    )}
    
    {/* Cancel Button */}
    {showCancel && (
      <GenericActionButton
        label={cancelLabel}
        icon={<Cancel />}
        onClick={onCancel}
        disabled={disabled}
        tooltipText={cancelTooltip}
      />
    )}
    
    {/* Finalize/Complete Button */}
    {showFinalize && (
      <GenericActionButton
        label={finalizeLabel}
        icon={<CheckCircle />}
        onClick={onFinalize}
        disabled={disabled || finalizeDisabled}
        tooltipText={finalizeTooltip}
      />
    )}
    
    {/* No Show Button */}
    {showNoShow && (
      <GenericActionButton
        label={noShowLabel}
        icon={<Delete />}
        onClick={onNoShow}
        disabled={disabled}
        tooltipText={noShowTooltip}
      />
    )}
    
    {showDownload && (
      <GenericActionButton
        label="Download"
        icon={<ArrowDownwardOutlinedIcon />}
        onClick={onDownload}
        disabled={disabled}
        tooltipText="Download"
      />
    )}
    {showSettleBill && (
      <GenericActionButton
        label="Settle Bill"
        icon={<LocalAtmOutlinedIcon />}
        onClick={onSettleBill}
        disabled={disabled}
        tooltipText="Settle Bill"
      />
    )}
    {showPrint && (
      <GenericActionButton
        label="Print"
        icon={<Print />}
        onClick={onPrint}
        disabled={disabled}
        tooltipText="Print"
      />
    )}
    {showSearchPatient && (
      <GenericActionButton
        label="Search Patient"
        icon={<SearchRounded />}
        onClick={onSearchPatient}
        disabled={disabled}
        tooltipText="Search Patient"
      />
    )}
    {showDelete && (
      <GenericActionButton
        label="Delete"
        icon={<Delete />}
        onClick={onDelete}
        disabled={disabled}
        tooltipText="Delete"
      />
    )}
    {showChangeDate && (
      <GenericActionButton
        label="Change Date"
        icon={<DateRange />}
        onClick={onChangeDate}
        disabled={disabled}
        tooltipText="Change Appointment Date"
      />
    )}
    {showDateRangeFilter && (
      <GenericActionButton
        label="Date Range"
        icon={<DateRange />}
        onClick={onDateRangeFilter}
        disabled={disabled}
        tooltipText="Filter by Date Range"
      />
    )}
    {showTodaysQueue && (
      <GenericActionButton
        icon={<FormatListNumberedOutlinedIcon />}
        onClick={onShowQueue}
        disabled={disabled}
        tooltipText="View Today's Queue"
      />
    )}
      {showRefresh && (
      <GenericActionButton
        label="Refresh"
        icon={<Refresh />}
        onClick={onRefresh}
        disabled={disabled}
        tooltipText="Refresh"
      />
    )}
  </Grid2>
);

export default MenuBar;